import { render, staticRenderFns } from "./ItemLauncher.vue?vue&type=template&id=f0d352d2&scoped=true"
import script from "./ItemLauncher.vue?vue&type=script&lang=ts"
export * from "./ItemLauncher.vue?vue&type=script&lang=ts"
import style0 from "./ItemLauncher.vue?vue&type=style&index=0&id=f0d352d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d352d2",
  null
  
)

export default component.exports